/**
 * Inline styles applied to the iframe element when expanding it to
 * fullscreen in the parent document. Used when the parent page is
 * same-origin but doesn't have Katal loaded (so we can't portal).
 *
 * Aligned with KatModal's overlay container (modal.lit.css.js):
 * - position: fixed + inset: 0 matches .container positioning
 * - z-index: 8250 matches --kat-z-index-modal
 *
 * CSS var() is not used because the parent document may not have
 * Katal CSS custom properties available.
 */
export const WIDGET_IFRAME_FULLSCREEN_STYLES: Partial<CSSStyleDeclaration> = {
  position: 'fixed',
  top: '0',
  left: '0',
  right: '0',
  bottom: '0',
  width: '100%',
  height: '100%',
  zIndex: '8250',
  border: 'none',
};
